import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase/FirebaseCredential";


const logError = async (error: any, name?: string) => {
  try {
    // Convert the error object to a JSON-safe representation
    const serializedError = JSON.parse(JSON.stringify(error));

    await addDoc(collection(db, 'errors'), {
      timestamp: new Date(),
      error: serializedError,
      function_name: name ?? ''
    });
    console.log("name", name);
  } catch (error) {
    console.error('Error logging:', error, name);
  }
};

export { logError };